function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
import sumBy from 'lodash/sumBy';
import { mapGetters } from 'vuex';
export default {
  props: {
    center: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fixedColumn: false
    };
  },
  mounted: function mounted() {
    this.initScroll();
  },
  updated: function updated() {
    this.initScroll();
  },
  computed: _objectSpread({}, mapGetters('api', ['resultType'])),
  methods: {
    headerWidth: function headerWidth() {
      return this.$refs.scrollBottom.querySelector('table tr td:first-child').offsetWidth;
    },
    visibleWidth: function visibleWidth() {
      return this.$refs.scrollBottom.clientWidth;
    },
    initScroll: function initScroll() {
      this.$refs.scrollTopContent.style.width = "".concat(this.$refs.scrollBottom.querySelector('table').scrollWidth, "px");
      var maxHeaderSize = this.$ncsConfig.result[this.resultType].maxHeaderSize || 50;
      this.fixedColumn = this.headerWidth() <= this.visibleWidth() * (maxHeaderSize / 100);

      if (this.center) {
        this.centerScroll();
      }
    },
    scrollTop: function scrollTop() {
      this.$refs.scrollBottom.scrollLeft = this.$refs.scrollTop.scrollLeft;
    },
    scrollBottom: function scrollBottom() {
      this.$refs.scrollTop.scrollLeft = this.$refs.scrollBottom.scrollLeft;
    },
    spaceBeforeCenter: function spaceBeforeCenter() {
      var before = this.$refs.scrollBottom.querySelectorAll('table tr:first-child td.before');

      if (before.length > 0) {
        return sumBy(before, function (e) {
          return e.offsetWidth;
        });
      } else {
        // If no before elements, return half of the cells total width
        return sumBy(this.$refs.scrollBottom.querySelectorAll('table tr:first-child td:not(:first-child)'), function (e) {
          return e.offsetWidth;
        });
      }
    },
    centerScroll: function centerScroll() {
      if (this.fixedColumn) {
        this.$refs.scrollBottom.scrollLeft = this.spaceBeforeCenter() - (this.visibleWidth() - this.headerWidth()) / 2;
      } else {
        this.$refs.scrollBottom.scrollLeft = this.headerWidth() + this.spaceBeforeCenter() - this.visibleWidth() / 2;
      }
    }
  }
};